import { render, staticRenderFns } from "./DxMonthlyPlanning.vue?vue&type=template&id=21fbe9e5&"
import script from "./DxMonthlyPlanning.vue?vue&type=script&lang=js&"
export * from "./DxMonthlyPlanning.vue?vue&type=script&lang=js&"
import style0 from "./DxMonthlyPlanning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports